//메인화면 메뉴리스트
import React, { useState, useEffect } from "react";
import IPut from 'iput';
//MUI
import { Checkbox, MenuItem, TextField } from '@mui/material';
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { theme } from '../../assets/themes';

import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";
const userLoginId = AuthenticationService.getLoggedInUserID();
/*const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000.000.000.000"
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
});*/

/*TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};*/
const date = new Date();
const now = date.toISOString().slice(0, 10);

const StoreModify = (props) => {
    const [branchs, setBranch]=useState([]);
    const [models, setModels] = useState([]);

    const modify = props.data;
    // console.log(modify);
    const onParamsChange = props.onParamsChange;
    const onCheckboxChange = props.onCheckboxChange;
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            await loadComboBoxBranch();
            await loadComboBoxModel();
        } catch (e) {
        }
        };
        getLoadData();
    }, []);
    // 콤보박스 데이터
    const loadComboBoxBranch = async () => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxModel = async() => {
        try{
            const res = await getAPI(API.COMMON.MODEL);
            const _inputData = res.data.result.map((m) => ({
                  cd: m.machKndCd,
                  name: m.machKndCd,
              })
          );
          setModels(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    return(
        <div className="pop-container">
            {/* 상단메뉴명 */}
            <div className="header">
                {fni18n('브랜드 등록/수정')}
            </div>
            <div className="contents">
            <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControl size="small" fullWidth>
                            <Select
                                name="branch"
                                value={modify.branch}
                                onChange={onParamsChange}
                            >
                                {branchs.map((map)=>(
                                    <MenuItem key={map.cd} value={map.cd}>
                                        {map.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('브랜드번호')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="storeCd"
                                value={modify.storeCd||""}
                                required
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('브랜드명')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="storeNm"
                                value={modify.storeNm||""}
                                required
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="description"
                                value={modify.description||""}
                                required
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControlLabel
                                sx={{mb:0, mt:0 }}
                                control={
                                    <Checkbox
                                    name="useYn"
                                    checked={modify.useYn}
                                    onChange={e => onCheckboxChange(e)}
                                    />
                                }
                            />
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
        </div>
    );
}

export default StoreModify;
